import { useAppSelector } from "../../../common/hooks/redux";

export default function useUtils() {
  const taskLabel = useAppSelector((state) => state.customs.taskLabel);

  return {
    addLinkLabel: `Link a ${taskLabel}`,
  };
}
